import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { VideoYoutube } from '@components/video-youtube/models';
import { YoutubePlayerComponent } from '@shared/components/youtube-player';
import { YoutubeIdExtractorPipe } from '@shared/components/youtube-player/pipes';

@Component({
  selector: 'app-video-youtube',
  imports: [YoutubePlayerComponent, YoutubeIdExtractorPipe],
  templateUrl: './video-youtube.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoYoutubeComponent extends AbstractDynamicComponent<VideoYoutube> {}
